import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSecondarySidebar } from '../../contexts/SecondarySidebarContext';
import { useSidebar } from '../../contexts/SidebarContext';

const HandleQuickCreate = ({
    title,
    FormComponent,
    createAction,
    settingsKey,
    formDataKey,
    moduleName,
    setFormData,
    setSettingsAction,
    sidebarType = 'secondary', // default to secondary for backward compatibility
    className = 'right-sidebar-md', // default size for backward compatibility
    onQuickCreateDone
}) => {
    const dispatch = useDispatch();
    const { toggleSecondarySidebar, closeSecondarySidebar } = useSecondarySidebar();
    const { toggleSidebar, closeSidebar } = useSidebar();
    const { settings } = useSelector(state => state[moduleName]);

    const handleCreate = useCallback(() => {
        const sidebarConfig = {
            className,
            title,
            content: (
                <FormComponent
                    onSave={async (data) => {
                        try {
                            const response = await dispatch(createAction(data));
                            
                            // Update settings if available
                            if (settings) {
                                const updatedItems = [
                                    ...(settings[settingsKey] || []),
                                    {
                                        id: response.id,
                                        label: response.label
                                    }
                                ];
                                
                                await dispatch(setSettingsAction({
                                    ...settings,
                                    [settingsKey]: updatedItems
                                }));
                            }

                            // Use the callback if provided, otherwise use default behavior
                            if (onQuickCreateDone) {
                                await setFormData(prev => onQuickCreateDone(response, prev));
                            } else {
                                // Set the newly created item in the form
                                setFormData(prev => ({
                                    ...prev,
                                    [formDataKey]: {
                                        id: response.id,
                                        label: response.label
                                    }
                                }));
                            }
                            
                            
                            return response;
                        } catch (error) {
                            console.error(`Error creating ${title.toLowerCase()}:`, error);
                            throw error;
                        }
                    }}
                    onClose={() => sidebarType === 'secondary' ? closeSecondarySidebar() : closeSidebar()}
                />
            ),
        };

        if (sidebarType === 'secondary') {
            toggleSecondarySidebar(sidebarConfig);
        } else {
            toggleSidebar(sidebarConfig);
        }
    }, [
        toggleSecondarySidebar, 
        closeSecondarySidebar, 
        toggleSidebar, 
        closeSidebar, 
        dispatch, 
        settings, 
        title, 
        FormComponent, 
        createAction, 
        settingsKey, 
        formDataKey, 
        setFormData, 
        setSettingsAction,
        sidebarType,
        className,
        onQuickCreateDone
    ]);

    return handleCreate;
};

export default HandleQuickCreate; 